<template>
	<div>
		<div style="text-align: right; padding-bottom: 20px;">
			<el-link type="primary" @click="exportXls">导出XLS</el-link>
		</div>
		<table id="table" class="dtable">
			<tr>

				<td>
					地区

				</td>

				<td style="background-color: #ccc;">
					五年高职计划

				</td>
				<td>
					投档人数
				</td>
				<td>
					报到人数
				</td>
				<td>
					投档报到率

				</td>
				<td>
					投档率

				</td>

				<td>
					实际报名人数

				</td>
				<td style="background-color: #ccc;">
					3+3专科计划

				</td>
				<td>
					投档人数
				</td>
				<td>
					报到人数
				</td>
				<td>
					投档报到率

				</td>
				<td>
					投档率

				</td>

				<td>
					实际报名人数

				</td>
				<td>
					合计

				</td>




			</tr>

			<tr v-for="(item,k,idx) in ShowDataList2" :key="'2'+k">

				<td>{{item.area_name}}</td>

				<td style="background-color: #ccc;">{{item.plan1}}</td>

				<td @click="nowtd=item.area_name+'5'">
					<input v-if="nowtd==item.area_name+'5'&&item.area_name!='合计'" type="text" @blur="setPara(item,5)"  v-model="item.td1" style="width: 60px" />
					<span v-else>{{item.td1}}</span>
				</td>
				<td>{{item.toudang1}}</td>

				<td>{{getLv(item.toudang1,item.td1)}}</td>

				<td>{{getLv(item.td1,item.plan1)}}</td>
				<td>{{item.baoming1}}</td>


				<td style="background-color: #ccc;">{{item.plan2}}</td>
				<td @click="nowtd=item.area_name+'3'">
					<input v-if="nowtd==item.area_name+'3'" type="text" @blur="setPara(item,3)"  v-model="item.td2" style="width: 60px" />
					<span v-else>{{item.td2}}</span>
				</td>
				<td>{{item.toudang2}}</td>

				<td>{{getLv(item.toudang2,item.td2)}}</td>
				
					<td>{{getLv(item.td2,item.plan2)}}</td>
				<td>{{item.baoming2}}</td>
				<td>{{item.baoming1+item.baoming2}}</td>
			</tr>

			<!-- <tr v-for="(item,k,idx) in heji_2" :key="'1'+k">
				<td colspan="2">小计</td>

				<td>{{item.plan}}</td>
				<td>{{item.plan}}</td>
				<td>{{item.fiveyear}}</td>
				<td>{{item.threeyear}}</td>
				<td>{{item.fiveyear+item.threeyear}}</td>
				<td>{{item.baodao}}</td>
				<td></td>
				<td></td>
			</tr> -->

		</table>

	</div>
</template>

<script>
	import XLSX from 'xlsx'
	export default {

		data() {
			return {
				year: localStorage.getItem("year"),
				students: [],
				ShowDataList1: [],
				ShowDataList2: [],

				heji_1: [],
				heji_2: [],
				zongji: [],
				luquStu: [],
				paraData:{},
				nowtd:""
			}
		},
		mounted() {
			this.getConfig();
			

		},
		methods: {
			getLv(a,b){
				if(b>0){
					return parseInt(a/b*10000)/100+"%"
				}else{
					return "0%"
				}
			},
			getConfig(){
				
				this.$http.post('/api/sys_sch_config_list', {
					ktype: 'toudang'
				}).then(res => {
					let data = res.data[0]
					data.kjson = JSON.parse(data.kjson)
					this.paraData = data
					this.getData();
				})
			},
			setPara(city,type){
				if(type==5){
					this.paraData.kjson[city.area_name+type] = city.td1
				}else{
					this.paraData.kjson[city.area_name+type] = city.td2
				}
				
				let data = JSON.parse(JSON.stringify(this.paraData))
				data.kjson = JSON.stringify(data.kjson)
				this.$http.post('/api/sys_sch_config_edit', data).then(res => {
					
				})
				this.nowtd=""
			},
			getData() {
				this.$http.post('/api/sch_area_major_data_dj', {
					status: 3
				}).then(res => {

					$("#loading").show();
					let fiveyear = {},
						threeyear = {};
					for (let item of res.data.majors) {
						if (item.item_desc.indexOf("五年") >= 0) {
							fiveyear[item.id] = 1
						} else {
							threeyear[item.id] = 1
						}
					}
					let area = res.data.area;
					for (let item of area) {
						item.plan1 = 0;
						item.td1=this.paraData.kjson[item.area_name+'5']?this.paraData.kjson[item.area_name+'5']:0;
						item.td2=this.paraData.kjson[item.area_name+'3']?this.paraData.kjson[item.area_name+'3']:0;
						item.toudang1 = 0;
						item.baoming1 = 0;
						item.tdlv1 = 0;
						item.plan2 = 0;
						item.toudang2 = 0;
						item.baoming2 = 0;
						item.tdlv2 = 0;
						for (let p of res.data.areaplan) {
							if (p.area_id == item.id && fiveyear[p.major_id]) {
								item.plan1 += p.num
							}
						}
						for (let p of res.data.students) {
							if (p.graduate_dist_code == item.area_code  && fiveyear[p.major_id]) {
								item.toudang1 += p.num
							}
						}
						if (item.plan1 > 0) {
							item.tdlv1 = parseInt(item.toudang1 / item.plan1 * 10000) / 100 + "%"
						} else {
							item.tdlv1 = 0;
						}
						
						for (let p of res.data.areaplan) {
							if (p.area_id == item.id && threeyear[p.major_id]) {
								item.plan2 += p.num
							}
						}
						for (let p of res.data.students) {
							if (p.graduate_dist_code == item.area_code  && threeyear[p.major_id]) {
								item.toudang2 += p.num
							}
						}
						if (item.plan2 > 0) {
							item.tdlv2 = parseInt(item.toudang2 / item.plan2 * 10000) / 100 + "%"
						} else {
							item.tdlv2 = 0;
						}
						
						
					}

					this.$http.post('/api/sch_area_major_data_dj', {
						status: 0
					}).then(res => {
						let heji={
							td1:0,
							td2:0,
							plan1:0,
							toudang1 :0,
							baoming1:0,
							tdlv1:0,
							plan2:0,
							toudang2 :0,
							baoming2 :0,
							tdlv2 :0,
						}
						for (let item of area) {

							for (let p of res.data.students) {
								if (p.graduate_dist_code == item.area_code&&fiveyear[p.major_id]) {
									item.baoming1 += p.num
								}else if (p.graduate_dist_code == item.area_code&&threeyear[p.major_id]) {
									item.baoming2 += p.num
								}
							}
							heji.area_name="合计"
							heji.plan1+=item.plan1;
							heji.td1+=parseInt(item.td1) ;
							heji.td2+=parseInt(item.td2);
							heji.toudang1+=item.toudang1;
							heji.baoming1+=item.baoming1;
							heji.plan2+=item.plan2;
							heji.toudang2+=item.toudang2;
							heji.baoming2+=item.baoming2;
							if (heji.plan1 > 0) {
								heji.tdlv1 = parseInt(heji.toudang1 / heji.plan1 * 10000) / 100 + "%"
							} else {
								heji.tdlv1 = 0;
							}
							if (heji.plan2 > 0) {
								heji.tdlv2 = parseInt(heji.toudang2 / heji.plan2 * 10000) / 100 + "%"
							} else {
								heji.tdlv2 = 0;
							}
						}
						
						area.push(heji)

						this.ShowDataList2 = area


						
					})







				})
			},
			getMajorPlan(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.num) {
						total += item.num
					}
				}
				return total
			},
			getFee(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.num) {
						total += item.num
					}
				}
				return total
			},
			getToudang(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.stu_num) {
						total += item.stu_num
					}
				}
				return total
			},


			exportXls() {
				let workbook = XLSX.utils.table_to_book(document.getElementById('table'))
				try {
					XLSX.writeFile(workbook, '已缴费人数统计表' + parseInt(Math.random() * 10000) + '.xlsx');
				} catch (e) {
					console.log(e, workbook);
				}
			}
		},
	}
</script>

<style scoped="scoped">
	.datatable {
		background-color: #E4E7ED;
		width: 100%;
	}

	.datatable td {
		background-color: #fff;
		text-align: center;
		padding: 10px 0;
	}
</style>
